<template>
    <div class="single-product__comments single-product__section" :class="{loading: loading}">
        <div class="single-product__section__header">
            <h3 class="single-product__section__title">دیدگاه کاربران</h3>
            <nav class="nav single-product__section__nav" v-if="false">
                <div class="single-product__section__nav-title">
                    <span class="icon-sort single-product__section__nav-title__icon"></span>
                    <span class="single-product__section__nav-title__text">مرتب سازی بر اساس:</span>
                </div>
                <a class="nav-link single-product__section__nav-link single-product__section__nav-link--active" aria-current="page" href="#">جدیدترین دیدگاه ها</a>
                <a class="nav-link single-product__section__nav-link" href="#">مفیدترین دیدگاه ها</a>
                <a class="nav-link single-product__section__nav-link" href="#">خریداران کالا</a>
            </nav>
        </div>
        <div class="single-product__comments__body" v-if="loaded">
            <div class="row gx-3 gx-lg-4">
                <div class="col-12 col-lg-6 order-2 order-lg-1" v-if="comments.length">
                    <div class="single-product__comment">
                        <span class="single-product__comment__recommend single-product__comment__recommend--true">
                            <span class="icon-Like"></span>پیشنهاد میکنم
                        </span>
                        <div class="single-product__comment__text">
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با
                            تولید سادگی نامفهوم از صنعت چاپ
                        </div>
                        <div class="single-product__comment__points">
                            <span class="single-product__comment__points__item single-product__comment__points__item--pos">
                                <span class="icon-Plus"></span>
                                نکات مثبت
                            </span>
                            <span class="single-product__comment__points__item single-product__comment__points__item--pos">
                                <span class="icon-Plus"></span>
                                نکات مثبت
                            </span>
                            <span class="single-product__comment__points__item single-product__comment__points__item--neg">
                                <span class="icon-Plus"></span>
                                نکات منفی
                            </span>
                        </div>
                        <div class="single-product__comment__footer">
                            <div class="single-product__comment__info">
                                <span class="single-product__comment__sender">عبدالحمید احمدی</span>
                                <span class="single-product__comment__dot"></span>
                                <span class="single-product__comment__date">30 بهمن 1399</span>
                            </div>
                            <div class="single-product__comment__rate">
                                <div class="single-product__comment__rate__like">
                                    <span class="icon-Like"></span>
                                    10
                                </div>
                                <div class="single-product__comment__rate__dislike">
                                    <span class="icon-Dislike"></span>
                                    0
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="single-product__comment">
                        <span class="single-product__comment__recommend single-product__comment__recommend--false">
                            <span class="icon-Dislike"></span>
                            پیشنهاد نمیکنم
                        </span>
                        <h5 class="single-product__comment__title">
                            درباره خرید تلویزیون 50اینچ جی پلاس
                        </h5>
                        <div class="single-product__comment__text">
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپلورم ایپسوم متن ساختگی با
                            تولید سادگی نامفهوم از صنعت چاپ
                        </div>
                        <div class="single-product__comment__points">
                            <span class="single-product__comment__points__item single-product__comment__points__item--pos">
                                <span class="icon-Plus"></span>
                                نکات مثبت
                            </span>
                            <span class="single-product__comment__points__item single-product__comment__points__item--pos">
                                <span class="icon-Plus"></span>
                                نکات مثبت
                            </span>
                            <span class="single-product__comment__points__item single-product__comment__points__item--neg">
                                <span class="icon-Plus"></span>
                                نکات منفی
                            </span>
                        </div>
                        <div class="single-product__comment__footer">
                            <div class="single-product__comment__info">
                                <span class="single-product__comment__sender">عبدالحمید احمدی</span>
                                <span class="single-product__comment__dot"></span>
                                <span class="single-product__comment__date">30 بهمن 1399</span>
                            </div>
                            <div class="single-product__comment__rate">
                                <div class="single-product__comment__rate__like">
                                    <span class="icon-Like"></span>
                                    10
                                </div>
                                <div class="single-product__comment__rate__dislike">
                                    <span class="icon-Dislike"></span>
                                    0
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 order-1 order-lg-2" :class="{'col-lg-6':comments.length, 'col-lg-12':comments.length===0}">
                    <div class="single-product__review">
                        <div class="single-product__review__inner" v-if="rating">
                            <div class="single-product__review__rate">
                                <h2 class="single-product__review__rate__num">4</h2>
                                <div class="single-product__review__rate__stars">
                                    <span class="icon-Star"></span>
                                    <span class="icon-Star"></span>
                                    <span class="icon-Star"></span>
                                    <span class="icon-Star"></span>
                                    <span class="icon-Star"></span>
                                </div>
                                <span class="single-product__review__rate__text">از مجموع 23 نظر</span>
                            </div>
                            <div class="single-product__review__performance">
                                <div class="single-product__review__performance__item">
                                    <span class="single-product__review__performance__text">کیفیت و شفافیت</span>
                                    <div class="progress single-product__review__performance__progress">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="single-product__review__performance__rate">3.8</span>
                                </div>
                                <div class="single-product__review__performance__item">
                                    <span class="single-product__review__performance__text">امکانات و قابلیت ها</span>
                                    <div class="progress single-product__review__performance__progress">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="single-product__review__performance__rate">3.8</span>
                                </div>
                                <div class="single-product__review__performance__item">
                                    <span class="single-product__review__performance__text">سهولت در کاربری</span>
                                    <div class="progress single-product__review__performance__progress">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="single-product__review__performance__rate">3.8</span>
                                </div>
                                <div class="single-product__review__performance__item">
                                    <span class="single-product__review__performance__text">ارزش در برابر قیمت</span>
                                    <div class="progress single-product__review__performance__progress">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="single-product__review__performance__rate">3.8</span>
                                </div>
                            </div>
                        </div>
                        <div class="single-product__review__add-comment">
                            <h3 class="single-product__review__add-comment__title">{{comments.length ? "اولین نظر را شما ثبت کنید" : "شما هم نظر دهید"}}</h3>
                            <p class="single-product__review__add-comment__text">
                                تجربه یا نظر خود در رابطه با این کالا را با دیگر کاربران به اشتراک بگذارید.
                            </p>
                            <a class="btn custom-btn custom-btn--secondary single-product__review__btn" :href="`/new-comment/${this.product.id}`">ارسال نظر جدید</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Comments.vue",
    data() {
        return {
            loaded: false,
            loading: true,
            comments: [],
            rating: {}
        }
    },
    computed: {
        product: {
            get() {
                return this.$store.state.product
            },
            set(value) {
                this.$store.commit('product/init', value);
            }
        },
        isLoaded() {
            return this.$store.getters['product/isLoaded'];
        },
    },
    methods: {
        request() {
            this.axios.get(this.route('api.product.comments.index', this.product.id)).then(response => {
                this.comments = response.data.data;
                this.rating = response.data.rating;
                this.loading = false;
                this.loaded = true;
            });
        }
    },
    watch: {
        isLoaded() {
            this.request();
        }
    }
}
</script>

<style scoped>

</style>
